import { Dimensions } from "react-native";

const deviceWidth = Dimensions.get('window').width;
const deviceHeight = Dimensions.get('window').height;

const fontSizeOptions = {
    title: 23,
    subtitle: 20,
    text: 16,  
    subtext: 10.5,
};

const colorsOptions = {
    red: 'rgb(171,61,53)',
    lightred: 'rgb(199, 52, 42)',
    green: '#407A52',
    lightgreen: 'rgb(80, 186, 130)',
    orange: '#C58E18',
    darkblue: '#5D8CAE',
    blue: 'rgb(32, 92, 152)',
    lightblue: 'rgb(31, 129, 186)',
    lighterblue: 'rgb(133,153,164)',
    gray: '#2f2f2f',
    lightGray: '#5f5f5f',
    stepIndicatorfinished: 'rgb(31, 129, 186)',
    stepIndicatorUnfinished: 'rgb(132, 153, 165)',
    unselected: 'rgba(200,200,200,.8)',
    backgroundColor : 'rgb(255,255,255)',
    textColor: '#484848',
};

const rootContainer = {
    maxWidth: 428,
    width: '100%',
    alignSelf: 'center',
}

export default {
    deviceWidth,
    deviceHeight,
    fontSizeOptions,
    colorsOptions,
    rootContainer,
}